import React from 'react';

import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import cls from './DistributeAmount.module.css';
import { DistributeAmountItem } from './DistributeAmountItem/DistributeAmountItem';

export const DistributeAmount = ({ formState, setFormState, isDisabled = false, error }) => {
    const { t } = useTranslation();

    const buttonHandler = () => {
        let percent = 0;
        let sum = 0;
        let estimateSelect = null;

        if (formState.distributeEstimates.length === 0) {
            percent = 100;
            sum = formState.sum;
            estimateSelect = formState.estimates;
        }

        let newDistributeEstimates;
        if (formState.distributeEstimates.length < 2) {
            newDistributeEstimates = [
                ...formState.distributeEstimates,
                { id: Date.now(), estimateSelect, sum, percent },
                { id: Date.now() + 2, estimateSelect: null, sum: 0, percent: 0 },
            ];
        } else {
            newDistributeEstimates = [
                ...formState.distributeEstimates,
                { id: Date.now() + 2, estimateSelect: null, sum: 0, percent: 0 },
            ];
        }

        setFormState((prevState) => ({
            ...prevState,
            distributeEstimates: newDistributeEstimates,
        }));
    };

    return (
        <div className={classNames(cls.distributeAmountWrapper, { [cls.disabled]: isDisabled })}>
            {formState.distributeEstimates.length > 1 && (
                <div className={classNames(cls.distributeAmountHead)}>
                    <span className={classNames(cls.modalLabelSelect)}>
                        {t('DistributeAmount.return.object_estimate')}
                    </span>
                    <span className={classNames(cls.headItem)}>%</span>
                    <span className={classNames(cls.headItem)}>
                        {t('DistributeAmount.return.sum')}
                    </span>
                </div>
            )}
            {formState.distributeEstimates.length > 1 && (
                <div className={classNames(cls.distributeAmountListWrapper)}>
                    {formState.distributeEstimates.map(({ id, estimateSelect, sum, percent }) => (
                        <DistributeAmountItem
                            isDisabled={isDisabled}
                            formState={formState}
                            setFormState={setFormState}
                            id={id}
                            key={id}
                            sum={sum}
                            percent={percent}
                            estimateSelect={estimateSelect}
                        />
                    ))}
                </div>
            )}
            {error && <span className={classNames(cls.errorMessage)}>{error}</span>}

            <div
                onClick={isDisabled ? () => {} : buttonHandler}
                className={classNames(cls.buttonWrapper, {
                    [cls.isActiveBlock]: formState.distributeEstimates.length <= 1,
                })}
            >
                <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M12.2669 7.36662H8.63353V3.73328C8.63353 3.38366 8.34983 3.09995 8.0002 3.09995C7.65057 3.09995 7.36686 3.38366 7.36686 3.73328V7.36662H3.73353C3.3839 7.36662 3.1002 7.65032 3.1002 7.99995C3.1002 8.34958 3.3839 8.63329 3.73353 8.63329H7.36686V12.2666C7.36686 12.6162 7.65057 12.9 8.0002 12.9C8.34983 12.9 8.63353 12.6162 8.63353 12.2666V8.63329H12.2669C12.6165 8.63329 12.9002 8.34958 12.9002 7.99995C12.9002 7.65032 12.6165 7.36662 12.2669 7.36662Z"
                        fill="#1094F7"
                        stroke="#1094F7"
                        strokeWidth="0.2"
                    />
                </svg>
                {t('DistributeAmount.return.buttonWrapper')}
            </div>
        </div>
    );
};
